import React from 'react'

export default function HiddenNetlifyForm() {
  return (
    <form
      name="free-estimate-form"
      data-netlify="true"
      data-netlify-honeypot="bot-field"
      hidden
      aria-hidden="true"
      style={{ display: 'none', visibility: 'hidden' }}
    >
      <input type="hidden" name="form-name" value="free-estimate-form" />
      <input type="text" name="firstname" />
      <input type="text" name="lastname" />
      <input type="email" name="email" />
      <input type="tel" name="phone" />
      <textarea name="description" />
      

      {/* System tracking fields */}
      <input type="hidden" name="subject" />
      <input type="hidden" name="url" />
      <input type="hidden" name="landingURL" />
      <input type="hidden" name="referrer" />
      <input type="hidden" name="session_source" />

      {/* Click ID fields */}
      <input type="hidden" name="gclid" />
      <input type="hidden" name="gbraid" />
      <input type="hidden" name="wbraid" />
      <input type="hidden" name="fbclid" />
      <input type="hidden" name="msclkid" />
      <input type="hidden" name="ttclid" />
      <input type="hidden" name="rdt_cid" />
      <input type="hidden" name="epik" />
      <input type="hidden" name="twclid" />

      {/* UTM parameters */}
      <input type="hidden" name="utm_source" />
      <input type="hidden" name="utm_medium" />
      <input type="hidden" name="utm_campaign" />
      <input type="hidden" name="utm_content" />
      <input type="hidden" name="utm_term" />

      {/* Bot honeypot */}
      <input type="text" name="bot-field" />
    </form>
  )
}